import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useMemo, useState, useEffect } from 'react';
import { useStyle } from '@magento/venia-ui/lib/classify';
import { useQuery } from '@apollo/client';
import LoadingIndicator from '@magento/venia-ui/lib/components/LoadingIndicator';
import defaultClasses from './frequentlyOrderedModal.module.css';
import { FormattedMessage } from 'react-intl';
import { Modal, ModalHeader, ModalBody } from '../Modal';
import WishlistCSS from 'src/overrides/venia-ui/components/Wishlist/WishlistDialog/wishlistDialog.module.css';
import ReqListCreation from './ReqListCreation';
import { QUERY_FOR_QUICK_ORDER_PRODUCT } from 'src/pages/Account/QuickOrder/queries.js';
import FrequentlyListSelect from './frequentlyListSelect';

var FrequentlyOrderedModal = function FrequentlyOrderedModal(props) {
  var _props$selectedItem, _data$products, _data$products$items;

  var loadingReq = props.loadingReq,
      fopData = props.fopData,
      refetch = props.refetch;
  var selectedItem = props.isWishlist ? (_props$selectedItem = props.selectedItem) === null || _props$selectedItem === void 0 ? void 0 : _props$selectedItem.product : props.selectedItem;
  var classes = useStyle(WishlistCSS, defaultClasses, props.classes);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSelectOpen = _useState2[0],
      setIsSelectOpen = _useState2[1];

  var _useQuery = useQuery(QUERY_FOR_QUICK_ORDER_PRODUCT, {
    variables: {
      filter: {
        sku: {
          eq: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.sku
        }
      }
    },
    skip: !(selectedItem !== null && selectedItem !== void 0 && selectedItem.sku),
    fetchPolicy: 'no-cache' // fetchPolicy: 'cache-and-network'
    // nextFetchPolicy: 'cache-first'

  }),
      data = _useQuery.data,
      loading = _useQuery.loading,
      error = _useQuery.error;

  var loader = useMemo(function () {
    return loadingReq || loading ? true : false;
  }, [loadingReq, loading]);
  useEffect(function () {
    return refetch();
  }, []);
  var productSku = props.productSku;
  var product = data === null || data === void 0 ? void 0 : (_data$products = data.products) === null || _data$products === void 0 ? void 0 : (_data$products$items = _data$products.items) === null || _data$products$items === void 0 ? void 0 : _data$products$items[0];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showCreation = _useState4[0],
      setShowCreation = _useState4[1];

  var maybeListsElement = useMemo(function () {
    if (fopData && product) {
      return React.createElement(FrequentlyListSelect, {
        list: fopData.customer.requisition_lists.items,
        productSku: productSku,
        isSelectOpen: isSelectOpen,
        setIsSelectOpen: setIsSelectOpen,
        closeModal: props.closeModal
      });
    } else {
      return null;
    }
  }, [fopData.customer.requisition_lists.items, product, isSelectOpen, setIsSelectOpen, productSku]);
  return React.createElement(Modal, {
    isOpen: props.isOpen,
    toggleModal: props.closeModal,
    classes: {
      modalWrapper: classes.modalWrapper,
      normalModal: classes.FOPnormalModal
    }
  }, React.createElement(ModalHeader, {
    title: !showCreation ? 'Update Frequently Order Products' : 'Create Frequently Ordered Products List',
    classes: {
      root: 'text-22 py-6 text-white bg-bronze px-8'
    },
    closeModal: props.closeModal
  }), React.createElement(ModalBody, {
    classes: {
      root: classes.body
    }
  }, loader ? React.createElement("div", {
    className: 'my-3 flex justify-center items-center',
    style: {
      height: '60vh'
    }
  }, React.createElement(LoadingIndicator, null, React.createElement(FormattedMessage, {
    id: 'reqModal.loadingText',
    defaultMessage: 'Loading data...'
  }))) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "flex justify-center flex-col"
  }, !showCreation ? React.createElement("div", {
    className: "px-20 pb-16"
  }, React.createElement("h5", {
    className: "text-center text-black mt-12"
  }, "Select your preferred list(s)."), React.createElement("div", {
    className: "".concat(classes.listHolder, " mt-12")
  }, maybeListsElement), React.createElement("div", {
    className: "flex justify-center mt-12"
  }, React.createElement("button", {
    onClick: function onClick() {
      return setShowCreation(true);
    },
    "aria-label": "Create a new list",
    className: "underline mx-auto"
  }, "Create a New List"))) : React.createElement(ReqListCreation, {
    refetch: refetch,
    setShowCreation: setShowCreation,
    closeModal: props.closeModal
  })))));
};

export default FrequentlyOrderedModal;